<div class="card-container">
    <div class="card-header-wrapper">
        <h3 class="card-title"> {{ customMsgService.translate('alterarPassword') }}</h3>
        <span></span>
    </div>

    <div class="card-component">

        <form class="k-form k-form-horizontal" style="max-width: 700px;width: 700px;" [formGroup]="formGroup">

            <fieldset class="k-form-fieldset">

                <kendo-formfield orientation="horizontal">
                    <kendo-label class="k-label" [text]="customMsgService.translate('atualPassword')"> </kendo-label>

                    <kendo-textbox formControlName="passwordOld" #passwordOld="kendoTextBox" required>
                        <ng-template kendoTextBoxSuffixTemplate>
                            <kendo-textbox-separator></kendo-textbox-separator>
                            <button kendoButton fillMode="flat" icon="eye" [toggleable]="true"
                                (selectedChange)="selectedChangeOld()"></button>
                        </ng-template>

                    </kendo-textbox>

                </kendo-formfield>
                <kendo-formfield orientation="horizontal">
                    <kendo-label class="k-label" [for]="password" [text]="customMsgService.translate('novaPassword')">
                    </kendo-label>

                    <kendo-textbox formControlName="password" #password="kendoTextBox" required>
                        <ng-template kendoTextBoxSuffixTemplate>
                            <kendo-textbox-separator></kendo-textbox-separator>
                            <button kendoButton fillMode="flat" icon="eye" [toggleable]="true"
                                (selectedChange)="selectedChange()"></button>
                        </ng-template>

                    </kendo-textbox>

                </kendo-formfield>

                <kendo-formfield orientation="horizontal">
                    <kendo-label [for]="passwordRewrite" [text]="customMsgService.translate('novaPasswordNovamente')">
                    </kendo-label>

                    <kendo-textbox formControlName="passwordRewrite" #passwordRewrite="kendoTextBox" required>
                        <ng-template kendoTextBoxSuffixTemplate>
                            <kendo-textbox-separator></kendo-textbox-separator>
                            <button kendoButton fillMode="flat" icon="eye" [toggleable]="true"
                                (selectedChange)="selectedChangeRe()"></button>
                        </ng-template>

                    </kendo-textbox>

                    <kendo-formerror>{{customMsgService.translate('passwordsNaoSaoIguais')}}</kendo-formerror>
                </kendo-formfield>

                <br />
                <hr />
                <br />

                <button kendoButton (click)="onSubmit()" themeColor="primary"
                    [disabled]="formGroup.invalid || formGroup.pristine">
                    {{ customMsgService.translate('saveChanges') }}
                </button>

            </fieldset>
        </form>
    </div>
</div>
<div kendoDialogContainer></div>